import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { recruitNowWebhookQueryKeys } from "./queryKeys";
import type {
  PaginatedRecruitNowWebhookOverviewResponse,
  UseRecruitNowWebhookOverviewParams,
} from "./types";

import { instance } from "@/lib/axios/instance";

export function useRecruitNowWebhookOverview(
  params: UseRecruitNowWebhookOverviewParams
) {
  return useQuery<
    PaginatedRecruitNowWebhookOverviewResponse,
    AxiosError
  >({
    queryKey: recruitNowWebhookQueryKeys.overviewList(params),
    queryFn: () =>
      instance
        .get<PaginatedRecruitNowWebhookOverviewResponse>(
          "/api/v2/Webhooks/RecruitNow/Overview",
          {
            params: {
              tenantId: params.tenantId,
              clientType: params.clientType,
              page: params.page ?? 1,
              pageSize: params.pageSize ?? 10,
              orderBy: params.orderBy,
              descending: params.descending,
              ...(params.status !== null && params.status !== undefined && { status: params.status }),
              ...(params.search && { search: params.search }),
            },
          }
        )
        .then((res) => res.data),
    placeholderData: keepPreviousData,
  });
}
